var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"back-button",attrs:{"icon":""},on:{"click":_vm.back}},[_c('v-icon',{attrs:{"color":"rgba(51, 51, 51, 1)","size":"34"}},[_vm._v("\n    "+_vm._s(_vm.mdiChevronLeft)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }